import { render, staticRenderFns } from "./addReceipt.vue?vue&type=template&id=31ad80e9&scoped=true"
import script from "./addReceipt.vue?vue&type=script&lang=js"
export * from "./addReceipt.vue?vue&type=script&lang=js"
import style0 from "./addReceipt.vue?vue&type=style&index=0&id=31ad80e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ad80e9",
  null
  
)

export default component.exports